import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { DynamicDashboardItem } from './dynamic-dashboard-item';

export enum DashboardLayout {
    OneByOne = '1 x 1',
    OneByTwo = '1 x 2',
    OneByThree = '1 x 3',
    OneByFour = '1 x 4',
    TwoByOne = '2 x 1',
    TwoByTwo = '2 x 2'
}

export class DynamicDashboardSection {
    layout: DashboardLayout = DashboardLayout.OneByOne;
    height: number = null;
    width: number = null;
    @Type(() => DynamicDashboardItem)
    dashboardItems: DynamicDashboardItem[] = [new DynamicDashboardItem()];

    get title(): string {
        return this.dashboardItems[0].title || '';
    }

    get direction(): string {
        return this.layout === DashboardLayout.TwoByOne ? 'vertical' : 'horizontal';
    }

    get minWidth(): number {
        if (Utils.isInList(this.layout, [DashboardLayout.OneByTwo, DashboardLayout.TwoByTwo])) {
            let width = Math.max(
                this.dashboardItems
                    .slice(0, 2)
                    .map((di) => di.minWidth || 0)
                    .reduce((x, y) => x + y),
                this.width || 0
            );
            if (Utils.equals(this.dashboardItems.length, 4)) {
                width = Math.max(
                    width,
                    this.dashboardItems
                        .slice(2, 4)
                        .map((di) => di.minWidth || 0)
                        .reduce((x, y) => x + y),
                    this.width || 0
                );
            }
            return width;
        }
        return Math.max(...this.dashboardItems.map((di) => di.minWidth || 0), this.width || 0);
    }

    get minHeight(): number {
        if (Utils.isInList(this.layout, [DashboardLayout.OneByTwo, DashboardLayout.TwoByTwo])) {
            let height = Math.max(
                this.dashboardItems
                    .slice(0, 2)
                    .map((di) => di.minHeight || 0)
                    .reduce((x, y) => x + y),
                this.height || 0
            );
            if (Utils.equals(this.dashboardItems.length, 4)) {
                height = Math.max(
                    Math.max(...this.dashboardItems.slice(0, 2).map((di) => di.minHeight || 0)) +
                        Math.max(...this.dashboardItems.slice(2, 4).map((di) => di.minHeight || 0)),
                    this.height || 0
                );
            }
            return height;
        }
        return Math.max(...this.dashboardItems.map((di) => di.minHeight || 0), this.height || 0);
    }

    get itemsWidth(): number {
        return Math.max(
            this.dashboardItems.map((di) => di.minWidth || 0).reduce((x, y) => x + y),
            this.width || 0
        );
    }

    get itemsHeight(): number {
        return Math.max(
            this.dashboardItems.map((di) => di.minHeight || 0).reduce((x, y) => x + y),
            this.height || 0
        );
    }

    validate(): boolean {
        let isValid = true;
        this.dashboardItems.forEach((di) => (isValid = isValid && di.validate()));
        return isValid;
    }

    resetRatios(): void {
        switch (this.layout) {
            case DashboardLayout.OneByOne:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 100;
                    d.heightRatio = 100;
                });
                break;
            case DashboardLayout.OneByTwo:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 50;
                    d.heightRatio = 100;
                });
                break;
            case DashboardLayout.OneByThree:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 33.34;
                    d.heightRatio = 100;
                });
                break;
            case DashboardLayout.OneByFour:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 25;
                    d.heightRatio = 100;
                });
                break;
            case DashboardLayout.TwoByOne:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 100;
                    d.heightRatio = 50;
                });
                break;
            case DashboardLayout.TwoByTwo:
                this.dashboardItems.forEach((d) => {
                    d.widthRatio = 50;
                    d.heightRatio = 50;
                });
                break;
        }
    }
}
